module.exports = __webpack_public_path__ + "img/so-will-ich-leben.041bcea9.jpg";